import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class IprcellService {

  constructor(private http: HttpClient) { }

  getMenu(){
  	let menuUrl = "http://api.thegbu.in/iprcellcontent/"
  	return this.http.get(menuUrl);
  }

  getPage(page){
  	let pageUrl = "http://api.thegbu.in/iprcellcontent/"+page;
  	return this.http.get(pageUrl, {responseType: 'text'});
  }

}



// WEBPACK FOOTER //
// ./src/app/services/iprcell.service.ts